module.exports = __webpack_public_path__ + "media/images/smart_phone/info-3e9939c59b995f67de968e6484452e49.png";